import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { useApiClient } from '../../../api/react'
import { useCanControl } from '../../../context/permissionsStore'
import { usePrinter } from '../../../context/printerContext'
import useServiceResponseHandler from '../../../services/useServiceResponseHandler'
import { AdaptiveButton } from '../../common/AdaptiveButton/AdaptiveButton'
import { WithConfirm } from '../../common/ConfirmModal'

type Props = {
  fileId: number
  onSuccess?: () => void
}

export function RemoveQueuedTransferAction({ fileId, onSuccess }: Props) {
  const { printer } = usePrinter()
  const { t } = useTranslation()
  const { displaySuccess } = useServiceResponseHandler()
  const api = useApiClient()
  const canControl = useCanControl(printer.team_id)

  const { mutate, isLoading } = useMutation(() => api.app.transfers.deleteTransfer(printer.uuid, fileId), {
    onSuccess: () => {
      displaySuccess(t('transfers.queue.deleted.title'), t('transfers.queue.deleted.body'))
      onSuccess?.()
    }
  })

  return (
    <WithConfirm title={t('transfers.queue.delete.title')} body={t('transfers.queue.delete.body')}>
      {(confirm) => (
        <AdaptiveButton
          icon="nokIcon"
          trigger={confirm(mutate)}
          label={t('button.delete')}
          isLoading={isLoading}
          isAvailable
          isDisabled={!canControl}
          disabledTooltip={t('printer.tooltip.rights')}
        />
      )}
    </WithConfirm>
  )
}
